import React from 'react';
import { connect } from 'react-redux';

import Icon from '@components/icon/Icon.tsx';

import AppButtonI from './types.ts';

import buttons from './static/buttons.ts';

class AppButton
    extends React.Component<AppButtonI['props'], AppButtonI['state']>
    implements AppButtonI
{
    parent: AppButtonI['parent'];

    constructor(props: AppButtonI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    buttons = buttons;

    render() {
        const { name, className = '' } = this.props;
        const button = this.buttons[name];

        return (
            <a
                className={`publicAppButton _col _${name} ${className}`}
                href={button.href}
                target="_blank"
                rel="noreferrer"
            >
                <div className="publicAppButton__inner">
                    <i className="publicAppButton__icon">
                        <Icon name={button.icon} />
                    </i>
                    Скачать в<br />
                    <span>{button.content}</span>
                </div>
            </a>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps)(AppButton);
